import * as React from 'react';
import styled, { css } from 'styled-components';

type ElementType = 'div' | 'hr' | 'li';

type DividerProps = {
    element?: ElementType;
    className?: string;
};

const dividerCss = css`
    width: 100%;
    height: 1px;
    margin: 0;
    border: none;
    background-color: ${({ theme }) => theme.bento.colors.border.main};
`;

const StyledDiv = styled.div`
    ${dividerCss}
`;

const StyledHr = styled.hr`
    ${dividerCss}
`;

const StyledLi = styled.li`
    ${dividerCss}
`;

const elementMap = {
    div: StyledDiv,
    hr: StyledHr,
    li: StyledLi,
};

export const Divider = React.memo<DividerProps>(({ element = 'hr', className }) => {
    const Component = elementMap[element];
    return <Component className={className} />;
});
